<div class="boxed">
  <div class="site-card">
    <h1 [innerHTML]="tOSTxt.agb_caption | i18next"></h1>
    <div [innerHTML]="tOSTxt.agb_content | i18next"></div>
  </div>
</div>
